import React, { Fragment } from "react";
import { IntlProvider } from "react-intl";
import { useSelector } from "react-redux";
import MfaCodeEntry from "./mfa/MfaCodeEntry";
import MfaSetup from "./mfa/MfaSetup";
import MfaChoice from "./mfa/MfaChoice";
import MfaTotp from "./mfa/MfaTotp";
import MfaMobilePhone from "./mfa/MfaMobilePhone";
import MfaEmail from "./mfa/MfaEmail";
import MfaTotpCodeEntry from "./mfa/MfaTotpCodeEntry";
import locales from "../i18n/locales";
import ChangePassword from "./ChangePassword";
import LoginFirstTime from "./login/LoginFirstTime";
import { ExistingSession } from "./login/ExistingSession";
import { ChangeEmailAddress } from "./email/ChangeEmailAddress";
import { ConfirmEmailAddress } from "./email/ConfirmEmailAddress";
import { SkipChangeEmailAddress } from "./email/SkipChangeEmailAddress";
import ForcedResetPassword from "./login/forcedPasswordReset";
import { ProviderDao } from "../redux/helpers/launchProvider";
import * as queryString from "query-string";
import CircularProgress from "@sterling-react/circular-progress";
import { LoginPrompt } from "./login/LoginPrompt";
import PropTypes from "prop-types";
import { Header } from "./Header";
import { Footer } from "./Footer";
import MfaForceDisabledBlurb from "./mfa/MfaForceDisabled";
import { NewFADVForgotPassword } from "./login/NewFADVForgotPassword";

export const Login = (props) => {
    let locale = useSelector(state => state.intl.locale) ?? props.defaultLocale;
    let flowStage = useSelector(state => state.loginForm.flowStage);
    const enableAutoIdpRedirect = useSelector(state => state.loginForm.enableAutoIdpRedirect);
    const s1TransportUser = useSelector(state => state.loginForm.s1TransportUser);
    const client_id = useSelector(state => state.loginForm.clientId);
    
    // Tailwind wants to resolve the asset inside this URL tag, so a symlink from `public/assets` into `node_modules/assets` can be used.
    let localeData;
    if (locales[locale]) {
        localeData = locales[locale].localeData;
    } else {
        locale = "en-us";
        localeData = locales[locale].localeData;
    }

    const providerDao = new ProviderDao(client_id);
    const savedProvider = providerDao.getSavedProvider();
    if (
        enableAutoIdpRedirect === true &&
        providerDao.checkAutoLaunchProvider(savedProvider) === true
    ) {
        flowStage = "REDIRECT_TO_IDP";
    }

    const parsedQueryString = queryString.parse(window.location.search);
    if (
        parsedQueryString.existingSession &&
        parsedQueryString.existingSession === "true"
    ) {
        flowStage = "AUTHENTICATED_CONFIRM_SINGLE_SESSION";
    }

    const Spinner = () => (<div className="py-10"> <CircularProgress size={75} /> </div>);

    let LoginComponent;
    // flowStage = "AUTHENTICATED_CONFIRM_SINGLE_SESSION"
    switch (flowStage) {
        case "MFA_SETUP":
            LoginComponent = MfaSetup;
            break;
        case "MFA_SETUP_TOTP":
            LoginComponent = MfaTotp;
            break;
        case "MFA_SETUP_SMS":
            LoginComponent = MfaMobilePhone;
            break;
        case "MFA_SETUP_EMAIL":
            LoginComponent = MfaEmail;
            break;
        case "SMS_MFA":
            LoginComponent = MfaCodeEntry;
            break;
        case "EMAIL_MFA":
            LoginComponent = MfaCodeEntry;
            break;
        case "SOFTWARE_TOKEN_MFA":
            LoginComponent = MfaTotpCodeEntry;
            break;
        case "SELECT_MFA_TYPE":
            LoginComponent = MfaChoice;
            break;
        case "NEW_PASSWORD_REQUIRED":
            LoginComponent = ChangePassword;
            break;
        case "EXPIRED_NEW_PASSWORD_REQUIRED":
            LoginComponent = ChangePassword;
            break;
        case "AUTHENTICATED_FIRST_TIME":
            LoginComponent = LoginFirstTime;
            break;
        case "CONFIRM_RESET_PASSWORD":
            if (s1TransportUser === true) {
                LoginComponent = ForcedResetPassword;
            } else {
                LoginComponent = NewFADVForgotPassword;
            }
            break;
        case "EMAIL_NOT_VERIFIED":
            LoginComponent = ChangeEmailAddress;
            break;
        case "VERIFY_EMAIL":
            LoginComponent = ConfirmEmailAddress;
            break;
        case "SKIP_EMAIL_NOT_VERIFIED":
            LoginComponent = SkipChangeEmailAddress;
            break;
        case "AUTHENTICATED_CONFIRM_SINGLE_SESSION":
            LoginComponent = ExistingSession;
            break;
        case "REDIRECT_TO_IDP":
            providerDao.launchProvider(savedProvider);
            LoginComponent = Spinner;
            break;
        case "FORCE_DISABLED_FACTOR":
            LoginComponent = MfaForceDisabledBlurb;
            break;
        case "LOGIN":
        default:
            LoginComponent = LoginPrompt;
            break;
    }

    return (
        <Fragment>
            <IntlProvider locale={locale} messages={localeData}>
                {/* The following should be added to the div below to reinstate the background image:
                style={{backgroundImage: `url(${props.baseUrl}/assets/bg-fadv-2025.svg)`}}*/} 
                <div className={"flex flex-col flex-1 min-h-0 bg-primary-bg bg-no-repeat bg-center dark:bg-blend-soft-light overflow-y-auto"}>
                    <Header logoUrl={props.logoUrl} />
                    <main className={"flex grow"}>
                        <div className="bg-primary-bg2 p-8 rounded shadow-md max-w-[700px] min-w-[375px] w-[50%] mx-auto my-10 z-30 h-fit">
                            <LoginComponent />
                        </div>
                    </main>
                    <div className='py-1' />
                    <Footer />
                </div>
            </IntlProvider>
        </Fragment>
    )
}
Login.propTypes = {
    logoUrl: PropTypes.string,
    baseUrl: PropTypes.string.isRequired,
    defaultLocale: PropTypes.string,
  }
